import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=40636c70&scoped=true&"
import script from "./Exit.vue?vue&type=script&lang=js&"
export * from "./Exit.vue?vue&type=script&lang=js&"
import style0 from "./Exit.vue?vue&type=style&index=0&id=40636c70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40636c70",
  null
  
)

export default component.exports